import React from 'react';
import { useTranslation } from 'react-i18next';
import './ProgressBar.css';
import { ProgressBarProps } from '../../types/interfaces';

const ProgressBar: React.FC<ProgressBarProps> = ({
  currentStages,
  totalStages,
  currentstep,
  data,
  isApproved = false,
}) => {
  const { t } = useTranslation();

  const currentStep: number = currentStages; // This indicates progress up to "Reviewer 2's Desk"

  return (
    <div className="cardBoard flex flex-col justify-start">
      <div className="mb-4 ml-10">
        <p className="text-xl font-semibold text-gray-700">
          {t('applicationProgress', 'Application Progress')}
        </p>
        <p className="text-md text-gray-500">
          {t(
            'applicationVerificationProgress',
            'This shows your application verification progress'
          )}
        </p>
        {isApproved && (
          <p className="text-md text-gray-500">
            {t(
              'congratulations',
              'Congratulations! Your supplier application has been approved, and you are now a verified supplier. You can now access tender opportunities and access all relevant features. Welcome aboard'
            )}
          </p>
        )}
      </div>

      <div className="w-[600px]">
        <div className="progress-container">
          {data?.map((step, index) => (
            <div className="step-container" key={index}>
              <div className={`circle ${index + 1 <= currentStep ? 'completed' : ''}`}>
                {index + 1}
              </div>
              <p className="step-label text-sm text-gray-500">{step?.workflowLevel}</p>
              {index + 1 < totalStages && (
                <div className={`line ${index + 1 < currentStep ? 'completed' : ''}`} />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
